/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'health-monitor';
const componentName = 'udp-health-monitor-config';
const prefix = `${moduleName}.${componentName}`;

export const sectionTitleUdp = `${prefix}.sectionTitleUdp`;
export const clientRequestHeaderInputLabel = `${prefix}.clientRequestHeaderInputLabel`;
export const clientRequestHeaderInputPlaceholder = `${prefix}.clientRequestHeaderInputPlaceholder`;
export const serverResponseDataInputLabel = `${prefix}.serverResponseDataInputLabel`;
export const serverResponseDataInputPlaceholder = `${prefix}.serverResponseDataInputPlaceholder`;
export const responseCodeInputLabel = `${prefix}.responseCodeInputLabel`;
export const responseCodeInputPlaceholder = `${prefix}.responseCodeInputPlaceholder`;

export const ENGLISH = {
    [sectionTitleUdp]: 'UDP',
    [clientRequestHeaderInputLabel]: 'Client Request Header',
    [clientRequestHeaderInputPlaceholder]: 'Enter Client Request Header',
    [serverResponseDataInputLabel]: 'Server Response Data',
    [serverResponseDataInputPlaceholder]: 'Enter Server Response Data',
    [responseCodeInputLabel]: 'Response Code',
    [responseCodeInputPlaceholder]: 'Select Response Code',
};
